import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

const baseIdPrefix = 'working-with-an-advisor';
const baseIdSuffix = 'faq';

export default () => (
  <SectionContainer
    id={`${baseIdPrefix}-${baseIdSuffix}`} // '-section-container' will be appended dynamically
    className='nmx-no-print'
    moduleName='faq-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        small={10}
        medium={8}
        large={6}>
        <Typography
          component='h2'
          nextElement='typography'>
          Questions about financial advisors&#63; <WidowBlock>We&#39;ve got answers.</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id={`faq-${baseIdPrefix}`}
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: `${baseIdPrefix}-do-i-need-a-financial-advisor-${baseIdSuffix}`,
              title: <>Do I need a <WidowBlock>financial advisor&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Anyone can benefit from expert financial advice&#8212;no matter where they&#39;re starting from. Our financial advisors will look at your big picture. They&#39;ll think of all the what&#45;ifs so you don&#39;t have to and guide you through life events big and small, like paying for college, buying a house, getting married, having a baby, adopting a child, retiring or inheriting assets. Sound good&#63;&nbsp;
                    <Link
                      id='working-with-an-advisor-who-needs-faq-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Get matched with an advisor today
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: `${baseIdPrefix}-help-with-what-${baseIdSuffix}`,
              title: <>What can a financial advisor help <WidowBlock>me with&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    Our financial advisors will look at your big picture. They&#39;ll think of all the what&#45;ifs so you don&#39;t have to, guiding you through life events big and small. From&nbsp;
                    <Link
                      id='working-with-an-advisor-help-with-what-investments-faq-link'
                      linkUrl='/investments/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about investment strategies.'>
                      investment strategies
                    </Link>
                    &nbsp;that can help grow your money to&nbsp;
                    <Link
                      id='working-with-an-advisor-help-with-what-insurance-faq-link'
                      linkUrl='/insurance/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about insurance.'>
                      insurance
                    </Link> that can help protect what you&#39;ve work so hard for, our advisors can show you the right financial steps to take you closer to the life you&#39;ve always wanted.
                  </Typography>
                  <Typography disableBottomPadding>
                    Ready to get started&#63;&nbsp;
                    <Link
                      id='working-with-an-advisor-help-with-what-advisor-faq-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Get matched with an advisor
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: `${baseIdPrefix}-best-way-to-rollover-${baseIdSuffix}`,
              title: <>How does a financial advisor get matched <WidowBlock>to me&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    We want to make sure you have the best experience possible. So we&#39;ll ask you a few questions about yourself, then we&#39;ll match you with an advisor who has the right expertise for your goals, experience working with other people like you, and has a good understanding of the area where you live. Let&#39;s get started.&nbsp;
                    <Link
                      id='working-with-an-advisor-best-way-to-rollover-faq-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Connect with one of our financial advisors
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: `${baseIdPrefix}-what-certifications-${baseIdSuffix}`,
              title: <>What certifications do Northwestern Mutual financial <WidowBlock>advisors have&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Our financial advisors have gone through special training to earn credentials indicating that they have the expertise to offer investment advice and insurance products to you. Our financial advisors will put your interests first. This means that any recommendations they make to you will be tailored to your specific needs, preferences, and financial circumstances. Want to talk with an advisor&#63;&nbsp;
                    <Link
                      id='working-with-an-advisor-what-certifications-faq-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'
                      ariaLabel='Get matched with one of our financial professionals.'>
                      Get matched with one
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: `${baseIdPrefix}-what-is-the-cost-${baseIdSuffix}`,
              title: <>What is the cost of working with a <WidowBlock>financial advisor&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    It depends on your needs. Most of our advisors will design a financial plan at no cost to you. Some advisors may charge a fee for certain types of planning, but they&#39;ll let you know up front. If you&#39;re looking for ongoing investment advice and services, you&#39;ll pay a quarterly fee based on the value of the assets in your account. To get more details,&nbsp;
                    <Link
                      id='working-with-an-advisor-what-is-the-cost-faq-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      talk to one of our advisors
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: `${baseIdPrefix}-help-with-retirement-planning-${baseIdSuffix}`,
              title: <>Can a financial advisor help me with <WidowBlock>retirement planning&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    They sure can. No matter where you&#39;re starting from, our advisors can show you the right financial steps to take you closer to the <Link
                      id='working-with-an-advisor-help-with-retirement-planning-retire-faq-link'
                      linkUrl='/retirement-planning/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about retirement planning.'>
                      retirement
                    </Link> you want. They&#39;ll think of all the what&#45;ifs so you don&#39;t have to and create a plan (at no cost to you) tailored from a range of top&#45;rated financial solutions designed to give you the flexibility and confidence to reach your retirement goals. Ready to get started&#63;&nbsp;
                    <Link
                      id='working-with-an-advisor-help-with-retirement-planning-advisor-faq-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'
                      ariaLabel='Get started with a financial professional.'>
                      Get matched with an advisor.
                    </Link>
                  </Typography>
                </>
              ),
            },
            {
              id: `${baseIdPrefix}-need-to-be-wealthy-${baseIdSuffix}`,
              title: <>Do I need to be wealthy to have a <WidowBlock>financial advisor&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Nope. No matter your situation or where you&#39;re starting from, our advisors are here to show you the right financial steps to take to help you reach your goals. Ready to get started&#63;&nbsp;
                    <Link
                      id='working-with-an-advisor-need-to-be-wealthy-faq-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Talk to an advisor
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: `${baseIdPrefix}-quote-without-connecting-${baseIdSuffix}`,
              title: <>Can I get a quote without connecting with a <WidowBlock>financial advisor&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Not currently. We value working with you to fully understand your needs and give you an accurate quote. Our advisors will show you what kind of&nbsp;
                    <Link
                      id='working-with-an-advisor-quote-without-connecting-faq-insurance-link'
                      linkUrl='/insurance/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about insurance.'>
                      insurance
                    </Link>
                    &nbsp;is right for you, and how much you&#39;ll need, to keep you and your family financially sound if the unexpected happens. Talk to an advisor about your needs.&nbsp;
                    <Link
                      id='working-with-an-advisor-quote-without-connecting-faq-advisor-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'
                      ariaLabel='Connect with one of our financial advisors today.'>
                      Connect with one today
                    </Link>.
                  </Typography>
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
